/**
 * Styled Components - Created by david on 09/04/18.
 */
import styled from 'styled-components'
import { GRAY_LIGHTEST, GRAY_DARK, RED, BLUE, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  .modal-info {
    background: red;
  }
`

export const FieldsContainer = styled.div`
  border: 1px solid #D7D1D2;
  margin-top: 30px;
  padding: 16px;
  border-radius: 8px;
  h1 {
    color: #302628;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
  }
`

export const Fields = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  color: #302628;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  ${({ secondary }: DivProps) => secondary ? `
    @media (max-width: 1280px) {
      flex-wrap: wrap;
    }
  ` : ''}
  @media (min-width: 320px) and (max-width: 480px) {
    flex-direction: column;
  }
`

export const Label = styled.div`
  display: flex;
  color: ${GRAY_DARK};
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 6px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 0;
  }
`

export const Required = styled.div`
  color: ${RED};
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 6px;
`

export const ColumnName = styled.div`
  max-width: 292px;
  margin-right: 20px;
  width: 100%;
  ${({ secondary }: DivProps) => secondary ? `
    @media (max-width: 1280px) {
      max-width: 238px;
    }
  ` : `
    max-width: 100%;
    margin-right: 0px;
  `}
  @media (max-width: 768px) {
    max-width: 228px;
  }
  @media (min-width: 320px) and (max-width: 698px) {
    width: 100%;
    max-width: 100%;
    margin-bottom: 24px;
  }
  input {
    border-radius: 8px;
    min-width: 244px;
  }
`

export const Column = styled.div`
  width: 200px;
  margin-right: 18px;
  input {
    border-radius: 8px;
  }
  @media (min-width: 320px) and (max-width: 698px) {
    width: 100%;
    max-width: 100%;
    margin-bottom: 24px;
  }
`

export const Error = styled.div`
  color: ${RED};
  font-size: 12px;
  line-height: 16px;
  padding: 4px;
`
export const TeamStoreTypeLabel = styled.img`
  border-radius: 6px;
  background-color: ${GRAY_LIGHTEST};
  font-family: Avenir Next;
  max-width: 162px;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  width: 100%;
  padding: 4px;
`

export const DirectShipLogo = styled.img`
  max-width: 124px;
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  color: #302628;
  @media (min-width: 320px) and (max-width: 698px) {
    flex-direction: column;
    div:first-child {
      align-self: flex-start;
    }
  }
  #backButton {
    display: inline-flex;
    cursor: pointer;
    padding: 8px 12px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #302628;
    background: #FFF;
  }
  h1 {
    flex-basis: 40%
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin: unset;
    @media (max-width: 698px) {
      margin-top: 20px;
    }
  }
`

export const RightLabels = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  height: 36px;
  flex-basis: 30%
  ${({ secondary }: DivProps) => secondary ? `
    height: auto;
    flex-flow: column;
    align-items: flex-end;
    @media (max-width: 698px) {
      align-items: center;
    }
  ` : ''}
  @media (max-width: 698px) {
    margin-top: 6px;
  }
`

export const Question = styled(Icon)`
  margin-top: 2px;
  margin-left: 8px;
  cursor: pointer;
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const inputStyle = {
  width: '100%',
  minWidth: '200px',
  borderRadius: '8px'
}

export const buttonStyle = {
  background: BLUE,
  border: 'none'
}

export const BulkShipTag = styled.div`
  background: #F7F0D0;
  line-height: normal;
  border: 1px solid #DCDCDC;
  border-radius: 5px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 5px;
  width: 220px;
  height: 48px;
  align-self: flex-end;
  margin-left: 12px;
  @media (max-width: 1140px) {
    margin-top: 20px;
  }
  @media (max-width: 768px) {
    margin: 0;
  }
  @media (max-width: 480px) {
    margin-right: 40px;
  }
`

export const BulkShipContainer = styled.div`
  text-align: right;
`

export const BulkShipTagDescription = styled.p`
  font-size: 13px;
  font-weight: bold;
  font-family: Avenir;
  margin: 0;
`

export const BulkShipTermsLink = styled.a`
  color: ${BLUE};
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
`

export const BulkShipTagIcon = styled.img`
  width: 26px;
`

export const TermsDiv = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EnabledLabel = styled.div`
  font-size: 12px;
  background: #ccf7d0;
  padding: 0px 8px;
  border-radius: 3px;
  align-self: flex-end;
`

export const ViewBulkShipButton = styled.div`
  border: 1px solid #aabcdc;
  height: fit-content;
  align-self: flex-end;
  padding: 8px 10px;
  border-radius: 3px;
  margin-left: 12px;
  margin-bottom: 6px;
  color: ${BLUE};
  box-shadow: 1px 2px 3px -1px #e5e5e5;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${BLUE};
    color: ${WHITE};
  }
  @media (max-width: 480px) {
    margin-right: 40px;
    margin-top: 12px;
  }
`

export const StyledTooltip = styled(Popover)``



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StoreForm/styledComponents.tsx